<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { useConfirmDialogs } from '@modules/core/composables/dialogs';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_GROUP_PENDING_WITHDRAWALS } from '@modules/pending-withdrawals/constants';
import { usePendingWithdrawalsAcceptMutation } from '@modules/pending-withdrawals/mutations';

import type {
  PendingWithdrawalsAcceptButtonEmits,
  PendingWithdrawalsAcceptButtonProps,
} from './types';

const props = withDefaults(defineProps<PendingWithdrawalsAcceptButtonProps>(), {});
const emit = defineEmits<PendingWithdrawalsAcceptButtonEmits>();

const { getTranslation } = useI18n();
const { confirmEdit } = useConfirmDialogs();
const { mutateAsync, isLoading } = usePendingWithdrawalsAcceptMutation();

function onConfirm(event?: MouseEvent): void {
  confirmEdit({
    event,
    header: getTranslation(TRANSLATION_GROUP_PENDING_WITHDRAWALS, 'APPROVE_TITLE').value,
    message: getTranslation(TRANSLATION_GROUP_PENDING_WITHDRAWALS, 'APPROVE_QUESTION').value,
    acceptLabel: getTranslation(TRANSLATION_GROUP_PENDING_WITHDRAWALS, 'APPROVE_YES').value,
    rejectLabel: getTranslation(TRANSLATION_GROUP_PENDING_WITHDRAWALS, 'APPROVE_NO').value,
    accept: () => {
      void mutateAsync(props.id).then(() => {
        emit('confirmed');
      });
    },
  });
}
</script>

<template>
  <VIconButton v-data-qa-auto-id="'PendingWithdrawalAcceptButton'"
    v-if="isIcon"
    icon="pi-check"
    severity="success"
    :loading="isLoading"
    @click="onConfirm"
  />
  <VButton
    v-else
    :label="$getTranslation(TRANSLATION_GROUP_PENDING_WITHDRAWALS, 'VIEW_APPROVE')"
    severity="success"
    :loading="isLoading"
    @click="onConfirm()"
  />
</template>
